import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [server, setServer] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("cctv_server") || "null");
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  const refreshMe = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  useEffect(() => {
    const token = localStorage.getItem("cctv_token");
    if (!token) {
      setLoading(false);
      return;
    }
    refreshMe()
      .catch(() => {
        localStorage.removeItem("cctv_token");
        localStorage.removeItem("cctv_server");
      })
      .finally(() => setLoading(false));
  }, []);

  const _doLogin = async (endpoint, payload) => {
    const { data } = await api.post(endpoint, payload);
    localStorage.setItem("cctv_token", data.token);
    localStorage.setItem("cctv_server", JSON.stringify(data.server));
    setServer(data.server);
    await refreshMe();
    return data.user;
  };

  const login = ({ server_ip, port, username, password }) =>
    _doLogin("/auth/login", { server_ip, port, username, password });

  const operatorLogin = ({ server_ip, port, username, password }) =>
    _doLogin("/auth/operator-login", { server_ip, port, username, password });

  const logout = () => {
    localStorage.removeItem("cctv_token");
    localStorage.removeItem("cctv_server");
    setUser(null);
    setServer(null);
  };

  return (
    <AuthContext.Provider value={{ user, server, loading, login, operatorLogin, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
